import { cliente } from '@/lib/cliente';
import type { GuardarTipoCasaSprints } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

/** Sprints (globales) por tipo de casa. */
export function useTiposCasaSprints() {
  return useQuery({
    queryKey: ['tipos-casa'],
    queryFn: () => cliente.tiposCasa.listar(),
  });
}

/** Guarda la secuencia de sprints de un tipo de casa. */
export function useGuardarTipoCasaSprints() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ tipo, body }: { tipo: string; body: GuardarTipoCasaSprints }) =>
      cliente.tiposCasa.guardar(tipo, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['tipos-casa'] });
    },
  });
}

/** Eficiencia (%) de la meta de % Crono Esperado (parámetro global). */
export function useEficienciaCrono() {
  return useQuery({
    queryKey: ['parametros', 'eficiencia-crono'],
    queryFn: () => cliente.parametros.eficienciaCrono(),
  });
}

/** Guarda la eficiencia (admin). Invalida los reportes: cambia el % Crono Esperado de la semana abierta. */
export function useGuardarEficienciaCrono() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (eficiencia: number) => cliente.parametros.guardarEficienciaCrono(eficiencia),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['parametros', 'eficiencia-crono'] });
      qc.invalidateQueries({ queryKey: ['reporte-semanal'] });
    },
  });
}
